import { render, staticRenderFns } from "./groupadd.vue?vue&type=template&id=1c608ace&scoped=true"
import script from "./groupadd.vue?vue&type=script&lang=js"
export * from "./groupadd.vue?vue&type=script&lang=js"
import style0 from "./groupadd.vue?vue&type=style&index=0&id=1c608ace&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c608ace",
  null
  
)

export default component.exports